/*
 * Copyright © 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */
import {IHttpService, ILogService, IPromise, IQService} from 'angular';
import TSZahlungsauftraegeSearchresultDTO from '../../models/TSZahlungsauftraegeSearchresultDTO';
import TSZahlungsauftragDTO from '../../models/TSZahlungsauftragDTO';
import IRootScopeService = angular.IRootScopeService;

/**
 * Service zum verwalten von Zahlungsauftrag Angaben
 *
 */
export default class ZahlungsauftragRS {
    serviceURL: string;

    static $inject = ['$http', 'CONSTANTS', '$q', '$rootScope', '$log'];

    /* @ngInject */
    constructor(private $http: IHttpService, private CONSTANTS: any, private $q: IQService,
                private $rootScope: IRootScopeService, private $log: ILogService) {
        this.serviceURL = this.CONSTANTS.REST_API + 'zahlungsauftrag';
    }

    public searchZahlungsauftraege(zahlungsauftraegeSearch: any): IPromise<TSZahlungsauftraegeSearchresultDTO> {
        return this.$http.post(this.serviceURL + '/search/', zahlungsauftraegeSearch, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response: any) => {
            this.$log.debug('PARSING zahlungsauftraege REST array object', response.data);
            return new TSZahlungsauftraegeSearchresultDTO().deserialize(response.data);
        });
    }

    public getZahlungsauftraegeForBeitrag(beitragId: string): IPromise<TSZahlungsauftragDTO> {
        return this.$http.get(this.serviceURL + '/beitrag/' + encodeURIComponent(beitragId))
            .then((response: any) => {
                this.$log.debug('PARSING gesuch REST object ', response.data);
                return new TSZahlungsauftragDTO().deserialize(response.data);
            });
    }

    public regenerateExcel(zahlungsauftragId: string): IPromise<string> {
        return this.$http.get(this.serviceURL + '/regenerateExcelReportZahlungAuftrag/' + encodeURIComponent(zahlungsauftragId))
            .then((response: any) => {
                return (response.data ? response.data.id : '');
            });

    }
}



// WEBPACK FOOTER //
// ./src/app/core/service/ZahlungsauftragRS.rest.ts